import Home from '../views/home';
import NotFound from '../views/404';
import Rating from '../views/rating';
import Payment from '../views/payment';
import Receipt from '../views/receipt';

////////////////////////////////////////////////////////////////////

export const HOME = '/';
export const NOT_FOUND = '*';
export const NOT_FOUND_CODE = '/404';
export const PAGE_404 = '/not-found';
export const PAYMENT = '/payment/:status/:inctype?';
export const RECEIPT = '/receipt/:token';
export const RATING = '/rating/:token+';

////////////////////////////////////////////////////////////////////

const routerList = [
  { router: HOME, page: <Home /> },
  { router: PAYMENT, page: <Payment /> },
  { router: RATING, page: <Rating /> },
  { router: RECEIPT, page: <Receipt /> },
  { router: NOT_FOUND_CODE, page: <NotFound /> },
  { router: NOT_FOUND, page: <NotFound /> },
];

export { routerList };
